import gql from 'graphql-tag';

export const getJobRoles = gql`
  query getJobRoles {
    getJobRoles {
      id
      name
      enabled
    }
  }
`;
